import script from "./SmButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmButton.vue?vue&type=script&lang=ts&setup=true"

import "./SmButton.vue?vue&type=style&index=0&id=29190f56&lang=scss"

const __exports__ = script;

export default __exports__